// Returns the nearest queryable root for an element. Inside a Shadow DOM this
// returns the ShadowRoot (so `querySelector` searches inside the shadow tree);
// otherwise returns `document`. Both support `querySelector`/`querySelectorAll`.
export const getQueryRoot = (
  el: Element | null | undefined
): Document | ShadowRoot => {
  const root = el?.getRootNode()
  if (root instanceof ShadowRoot) return root
  return document
}
